module.exports = __webpack_public_path__ + "static/lageplan_einkaufen_mini-4f79270d0d1062364025c8424449b54a.png";